var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"width":640,"title":123,"placement":"right","closable":true,"visible":_vm.visible,"after-visible-change":_vm.afterVisibleChange},on:{"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }